module.exports = __webpack_public_path__ + "static/img/exposure-mobile-1.657db188.png";